import * as React from 'react';
import { Col, Row } from 'antd';
import { observer } from 'mobx-react';

import { DataLocalService } from 'src/core/services/data-local.service';
import { BooleanView } from 'src/core/ui/boolean.view';
import { DataTableView, Column, ToolbarVisibility } from 'src/core/ui/data-table.view';
import { TooltipView } from 'src/core/ui/tooltip.view';

interface PaxProductOccupancyProps {
	paxs: PersonOccupancy[];
	entries: EntryOccupancyPax[]
	setBusy(isBusy: boolean);
	mode: ControlMode;
}

@observer
export class PaxProductOccupancyView extends React.Component<PaxProductOccupancyProps, {}> {
	constructor(props: Readonly<PaxProductOccupancyProps>) {
		super(props);
	}
	private get columns(): Column[] {
		let firstColumn = {
			key: 'unit',
			title: (<span>Product</span>),
			dataIndex: 'unit',
			render: (text: string, record: EntryOccupancyPax, index: number) => {
				return <React.Fragment>
					<span>{record.title + "  "}</span>
				</React.Fragment>
			}
		};
		let restColumn = this.props.paxs.map(e => ({
			key: e.id.toString(),
			title: (
				<TooltipView title={`${e.name} (${e.age})`}>
					<span>{e.name}</span>
				</TooltipView>
			),
			dataIndex: e.id.toString(),
			render: (text: string, record: EntryOccupancyPax) => (
				<BooleanView
					mode={this.props.mode}
					value={record[e.id]}
					onChanged={newVal => {
						record[e.id] = newVal;
						const entry = record;
						// aqui se actualizan los entry.occupancy, entry.costPriceResult.breakdown y entry.sellPriceResult.breakdown
						if (newVal) { // adicionar al pax a la ocupacion
							let entriesSameProduct = this.props.entries.filter(e =>
								e.productId == entry.productId &&
								e.productExternalId == entry.productExternalId &&
								e.supplierId == entry.supplierId &&
								e.entryId != entry.entryId &&
								e.dateFrom.toDateString() == entry.dateFrom.toDateString() &&
								e.dateTo.toDateString() == entry.dateTo.toDateString());
							for (const entry1 of entriesSameProduct) { // un pax no puede estar al mismo tiempo en dos lugares que pertenecen al mismo producto en la misma fecha.
								const paxIndex = this.props.paxs.findIndex(p => p.id == e.id);
								const costPriceBreakdownIndex = entry1.breakdownCost ? entry1.breakdownCost.findIndex(c => c.paxId == e.id) : -1;
								const sellPriceBreakdownIndex = entry1.breakdownSell ? entry1.breakdownSell.findIndex(c => c.paxId == e.id) : -1;
								if (paxIndex != -1) {
									entry1.occupancy = entry1.occupancy.filter(o => o.id !== e.id);
									entry1[e.id] = false;
								}
								if (costPriceBreakdownIndex != -1) {
									entry1.breakdownCost.splice(costPriceBreakdownIndex, 1);
								}
								if (sellPriceBreakdownIndex != -1) {
									entry1.breakdownSell.splice(sellPriceBreakdownIndex, 1);
								}
							}
							let moneyBreakdown: MoneyBreakdown = {
								paxId: e.id,
								exchangeRate: 0,
								price: 0,
								unitPrice: 0,
								priceType: '',
								percent: false,
							};

							if (entry.breakdownCost == null)
								entry.breakdownCost = [];
							entry.breakdownCost.push(moneyBreakdown);
							if (entry.breakdownSell == null)
								entry.breakdownSell = [];
							entry.breakdownSell.push(moneyBreakdown);
							if (entry.occupancy == null)
								entry.occupancy = [];
							const pax = this.props.paxs.find(o => o.id == e.id);
							entry.occupancy.push({ id: pax.id, type: 0 });
							this.forceUpdate();
						} else { // quitar al pax de la ocupacion
							const paxIndex = this.props.paxs.findIndex(p => p.id == e.id);
							const costPriceBreakdownIndex = entry.breakdownCost ? entry.breakdownCost.findIndex(c => c.paxId == e.id) : -1;
							const sellPriceBreakdownIndex = entry.breakdownSell ? entry.breakdownSell.findIndex(c => c.paxId == e.id) : -1;
							if (paxIndex != -1) {
								entry.occupancy = entry.occupancy.filter(o => o.id !== e.id);
							}
							if (costPriceBreakdownIndex != -1) {
								entry.breakdownCost.splice(costPriceBreakdownIndex, 1);
							}
							if (sellPriceBreakdownIndex != -1) {
								entry.breakdownSell.splice(sellPriceBreakdownIndex, 1);
							}
							if (paxIndex != -1 || costPriceBreakdownIndex != -1 || sellPriceBreakdownIndex != -1) {
								this.forceUpdate();
							}
						}
					}}
				/>
			)
		})).slice();
		let result = [firstColumn].concat(restColumn);
		return result;
	}

	private get dataSet(): DataLocalService<any> {
		return new DataLocalService(this.props.entries);
	}
	render() {
		if (this.props.entries == null || this.props.paxs == null) {
			return null;
		}
		return (
			<Row>
				<Col xs={24}>
					<DataTableView
						rowKey="entryId"
						mode={this.props.mode}
						setBusy={this.props.setBusy}
						columns={this.columns}
						model={this.dataSet}
						hideToolbar={ToolbarVisibility.hideSearch | ToolbarVisibility.hidePagination | ToolbarVisibility.hideModifyButtons}
						selection={false}
					/>
				</Col>
			</Row>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/quote-entries/parts/pax-product-occupancy.view.tsx